export default "__VITE_ASSET__Cl_Ghu9i__"